import repository from "../Repository";

export default {
  // 生徒情報の一覧を取得する
  async getStudents(manageGrpId, screenId) {
    const res = await repository.post(
      `student_info`,
      { manage_grp_id: manageGrpId },
      {
        headers: { s: screenId }
      }
    );
    return res;
  },

  // 生徒情報を登録する
  async registerStudent(studentInfo, screenId) {
    const res = await repository.post(`student_ope`, studentInfo, {
      headers: { s: screenId }
    });
    return res;
  },

  // 生徒情報を編集する
  async updateStudent(studentInfo, screenId) {
    const res = await repository.patch(`student_ope`, studentInfo, {
      headers: { s: screenId }
    });
    return res;
  }
};
